import React, { useState, useMemo } from 'react';
import {
  Widget,
  GridView,
  SimpleView,
  Button,
  FormatText
} from '@digital/ui';
import FiltrosRelatorioCiclorOrcamentario from './FiltrosRelatorioCicloOrcamentario';
import { Collapse, Icon } from 'antd';
import {
  CrfCicloOrcamentarioRelatorio,
  CrfFiltros,
  postGetAllRelatorioCicloOrcamentarioPluriAnual
} from '@app/api/crf/crfRelatorioCicloorcamentario'

import TableCicloOrcamentarioPluriAnualProps from './TableCicloOrcamentarioPluriAnual';
import { exportaRelatorioPluriAnualExcel } from '@app/api/crf/crfRelatorioProjetoPacote';

const CrfRelatorioCicloOrcamentarioPluriAnual = () => {
  const { Panel } = Collapse;
  const [cicloOrcamentarioRelatorioTotal, setCicloOrcamentarioRelatorioTotal] = useState<CrfCicloOrcamentarioRelatorio>();

  const handleFilter = (filtros: CrfFiltros) => {
    postGetAllRelatorioCicloOrcamentarioPluriAnual(filtros).then((data) => {
      setCicloOrcamentarioRelatorioTotal(data);
    });
    return true;
  }

  const hasExpostarRelatorio = (filtros: CrfFiltros) => {
    exportaRelatorioPluriAnualExcel(filtros);
  }

  const btnExportar = () => {

    return [
      <Button
        type="primary"
        name="btnExportar"
        icon="files-ms_excel"
        onClick={() => {
          hasExpostarRelatorio({} as CrfFiltros);
        }}>
        <FormatText id="data-export" uppercase transform={() => "Exportar Relatório"} />
      </Button>,
    ]
  }

  return (
    <SimpleView >
      <GridView noform>
        <FiltrosRelatorioCiclorOrcamentario
          onSearch={handleFilter}
          atualizarTela={() => { }} />
        {(cicloOrcamentarioRelatorioTotal) ? (
          <Widget
            title="RESULTADO"
            span={12}
            actions={btnExportar()}>
            <TableCicloOrcamentarioPluriAnualProps
              cicloOrcamentarioRelatorioTotal={cicloOrcamentarioRelatorioTotal}
              ocultarColunaDetalhe={false}
              paginacaoConfig={{
                pageSize: 25,
                onChange: (() => {
                  document.getElementById("tableCicloOrcamentarioPluriAnual").scrollIntoView();
                })
              }} />
          </Widget>
        ) : (<> </>)}
      </GridView>
    </SimpleView>
  );
};

export default CrfRelatorioCicloOrcamentarioPluriAnual;